import React from 'react'

import { Anchor } from './styles'

const TextLink = ({ children, ...rest }) => (
  <Anchor {...rest}>{children}</Anchor>
)

export default TextLink
